<template>
    <div class="configurator__content">
        <div class="configurator__steps">
            <configurator-step v-for="(step, index) in moduleConfigurator.steps" :key="step.RKEY"
                               :items="step.ITEMS" :title="step.TITLE" :number="index + 1"
                               :parent="step.PARENT" :template="step.TEMPLATE"
                               :description="step.DESCRIPTION" :selected="step.SELECTED"></configurator-step>
        </div>
        <a v-if="showBtn" class="configurator__confirm btn btn--middle" @click="SET_STEPS">Подтвердить конфигурацию</a>
        <selected-configuration></selected-configuration>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SelectedConfiguration from "@/components/Configurator/SelectedConfiguration";
import ConfiguratorStep from "@/components/Configurator/ConfiguratorStep";

export default {
    name      : "ProductConfigurator",
    components: {SelectedConfiguration, ConfiguratorStep},
    created() {
        this.GET_STEPS();
    },
    computed: {
        ... mapState([
            'moduleConfigurator'
        ]),
        showBtn() {
            let show = this.moduleConfigurator.steps.length;
            if (show < 1) return false;
            return this.moduleConfigurator.steps[show - 1]['showNext'] === true;
        }
    },
    methods : {
        ... mapActions([
            'GET_STEPS', 'SET_STEPS'
        ]),
    },
}
</script>

<style scoped>

</style>